import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { Suspense } from "react";
import { z } from "zod";
import { serversQueryOptions } from "@/app/servers/api/get-servers";
import { ServersListSkeleton } from "@/app/servers/components/servers-list-skeleton";
import { ServersList } from "@/app/servers/list/list";
import { nameFilterSchema } from "@/components/custom/filters/name-filter";
import {
  scopeFilterSearchDefaults,
  scopeFilterSearchSchema,
} from "@/components/custom/resources/scope-filter";

const serversViewSchema = z.enum(["servers", "browse"]);

const serversParamsSchema = z.object({
  view: serversViewSchema.catch("servers").default("servers"),
  // The Browse tab's search. Held in the URL like the tab itself, so a
  // filtered catalog survives a reload and can be linked to.
  q: z.string().catch("").default(""),
  serverTypes: z.array(z.string()).catch([]).default([]),
  statuses: z.array(z.string()).catch([]).default([]),
  ...nameFilterSchema.shape,
  ...scopeFilterSearchSchema.shape,
});

const defaultValues = {
  view: "servers" as const,
  q: "",
  name: "",
  serverTypes: [],
  statuses: [],
  ...scopeFilterSearchDefaults,
};

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/servers/"
)({
  validateSearch: serversParamsSchema,
  search: {
    middlewares: [stripSearchParams(defaultValues)],
  },
  component: (): React.JSX.Element => (
    <Suspense fallback={<ServersListSkeleton />}>
      <ServersList />
    </Suspense>
  ),
  loader: ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(
      serversQueryOptions({ binding: "project", scope: params })
    );
    return { crumb: "Servers" };
  },
});
